/**
 * "Back to <report>" — the return leg of a report's deep link.
 *
 * Renders nothing unless a ticket is set, so it costs an unrelated visit to this screen
 * precisely one sessionStorage read. See returnTicket.ts for why the ticket exists.
 */

import React, { useEffect, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { ReturnTicket, goBackToReport, readReturnTicket } from './returnTicket';

export default function ReturnToReportBanner() {
  const [ticket, setTicket] = useState<ReturnTicket | null>(null);

  // Read on mount rather than during render: sessionStorage is not reactive, and reading
  // it in the body would re-run on every parent render of a very large component.
  useEffect(() => {
    setTicket(readReturnTicket());
  }, []);

  if (!ticket) return null;

  return (
    <div className="mb-4 flex items-center justify-between gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-2 dark:border-blue-800 dark:bg-blue-900/30">
      <p className="text-sm text-blue-900 dark:text-blue-200">
        You came here from <strong>{ticket.label}</strong>. Save your changes, then go back to
        re-check the invoice.
      </p>
      <button
        type="button"
        onClick={() => goBackToReport(ticket)}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-blue-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-700"
      >
        <ArrowLeft className="w-4 h-4" /> Back to {ticket.label}
      </button>
    </div>
  );
}
